export default {"src":"/_next/static/media/GlossaryNoResultIcon.319f3036.svg","height":63,"width":53,"blurWidth":0,"blurHeight":0};